import { __awaiter, __decorate } from "tslib";
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WebClientService } from '../../../services/webclient-settings.service';
import { LanguageService } from '../../../services/language.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { SharedHttp } from '../../../services/http-client.service';
import { AuthService } from '../../../services/auth.service';
let UserDocumentationComponent = class UserDocumentationComponent {
    constructor(webSettingsService, languageService, sanitizer, themeService, httpClient, auth) {
        this.webSettingsService = webSettingsService;
        this.languageService = languageService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.auth = auth;
        this.borderRadiusLarger = '';
        this.lang = '';
        this.displayFiles = [];
        this.filesToUpload = [];
        this.fileSizeError = false;
        this.fileSize = 0;
        this.numberOfFiles = 0;
        this.userDocumentVerificationUpload = false;
        this.documentsSubmitted = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.languageService.getChosenLanguage().subscribe((lang) => {
            this.lang = lang ? lang : 'en';
        });
        this.fetchUser();
    }
    ngOnInit() {
        this.getVerificationSettings();
    }
    fetchUser() {
        this.auth.fetchUser().then((data) => {
            this.user = JSON.parse(localStorage.getItem('user'));
        });
    }
    getVerificationSettings() {
        this.webSettingsService.getSettings().subscribe((data) => {
            const size = this.webSettingsService.getCustomValue('VERIFY.ALLOWED_VERIFICATION_FILE_SIZE.VALUE');
            const parsedSize = parseInt(size);
            this.fileSize = (size !== '' && parsedSize) ? parsedSize : 0;
            const nmb = this.webSettingsService.getCustomValue('VERIFY.NUMBER_OF_VERIFICATION_FILES.VALUE');
            const parsedNumber = parseInt(nmb);
            this.numberOfFiles = (nmb !== '' && parsedNumber) ? parsedNumber : 0;
        });
    }
    fileChange(event) {
        this.filesToUpload = event.target.files;
        this.displayFiles = this.toArray(this.displayFiles).concat(this.toArray(this.filesToUpload));
        for (let i = 0; i < this.displayFiles.length; i++) {
            const fileExtension = this.displayFiles[i].name.split('.').pop();
            const allowed = this.checkFileExtension(fileExtension);
            if (this.displayFiles[i].size > 1024 * 1024 * this.fileSize || !allowed) {
                this.fileSizeError = true;
                break;
            }
            else {
                this.fileSizeError = false;
            }
        }
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.formSubmitted = true;
            const formData = new FormData();
            const files = this.displayFiles;
            for (let i = 0; i < files.length; i++) {
                formData.append(files[i].name, files[i]);
            }
            const documentationFiles = [];
            const readUploadedFileAsDataURL = (file) => {
                const temporaryFileReader = new FileReader();
                return new Promise((resolve) => {
                    temporaryFileReader.onload = () => {
                        resolve(temporaryFileReader.result);
                        const tempFile = {
                            name: file.name,
                            content: temporaryFileReader.result
                        };
                        documentationFiles.push(tempFile);
                    };
                    temporaryFileReader.readAsDataURL(file);
                });
            };
            for (let i = 0; i < files.length; i++) {
                yield readUploadedFileAsDataURL(files[i]);
            }
            this.httpClient.post('user/userdocumentation', {
                user_id: this.user.id,
                documentation_files: documentationFiles
            }).subscribe((success) => {
                this.documentsSubmitted.emit(true);
            });
        });
    }
    removeFile(file) {
        if (this.displayFiles.length === 1) {
            this.displayFiles = [];
        }
        else {
            for (let i = 0; i < this.displayFiles.length; i++) {
                if (this.displayFiles[i].name === file.name) {
                    this.displayFiles.splice(i, 1);
                }
            }
        }
        this.validateFiles();
    }
    validateFiles() {
        for (let i = 0; i < this.displayFiles.length; i++) {
            if (this.displayFiles[i].size > 1024 * 1024 * this.fileSize) {
                this.fileSizeError = true;
                break;
            }
            else {
                this.fileSizeError = false;
            }
        }
    }
    toArray(fileList) {
        return Array.prototype.slice.call(fileList);
    }
    checkFileExtension(fileExtension) {
        const allowedExtensions = ['jpg', 'png', 'jpeg', 'pdf', 'gif', 'JPG', 'JPEG', 'PNG', 'PDF', 'GIF'];
        return allowedExtensions.includes(fileExtension);
    }
    roundNumber(num, places) {
        return Math.round(num * Math.pow(10, places)) / Math.pow(10, places);
    }
};
UserDocumentationComponent.ctorParameters = () => [
    { type: WebClientService },
    { type: LanguageService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: SharedHttp },
    { type: AuthService }
];
__decorate([
    Input()
], UserDocumentationComponent.prototype, "userDocumentVerificationUpload", void 0);
__decorate([
    Output()
], UserDocumentationComponent.prototype, "documentsSubmitted", void 0);
UserDocumentationComponent = __decorate([
    Component({
        selector: 'ecd-user-documentation',
        template: __importDefault(require("./user-documentation.component.html")).default
    })
], UserDocumentationComponent);
export { UserDocumentationComponent };
